<template>
    <Header></Header>
    <main>
        <BreadCrumbs></BreadCrumbs>
        <section class="status__container" v-if="!machine">
            <div class="status" v-if="error === 'not_found'">
                This machine is no longer available.
                <router-link :to="{ name: 'ugm-machines' }">Back to all machines</router-link>
            </div>
            <div class="status" v-else-if="error">The catalogue is temporarily unavailable. Please try again later.</div>
            <div class="status" v-else>Loading…</div>
        </section>
        <template v-else>
            <MainContentWrapper>
                <template #slider>
                    <SliderImages
                        v-if="machine.images.length > 0"
                        :key="machine.sku"
                        :images="machine.images.map(image => image.full)"
                        :thumbs="machine.images.map(image => image.thumb)"
                    ></SliderImages>
                </template>
                <template #info><UgmMachineInfo :machine="machine"></UgmMachineInfo></template>
            </MainContentWrapper>
            <UgmMachineTabs :key="machine.sku" :machine="machine"></UgmMachineTabs>
            <UgmRelated v-if="related.length > 0" :products="related"></UgmRelated>
        </template>
        <FaqBlock style="padding-bottom: 120px;"></FaqBlock>
    </main>
    <Footer></Footer>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import Footer from "@/components/Footer/Footer.vue";
import BreadCrumbs from "@/components/UI/BreadCrumbs.vue";
import FaqBlock from "@/components/Templates/FaqBlock.vue";
import MainContentWrapper from "@/components/Product/MainContentWrapper.vue";
import SliderImages from "@/components/Product/Tabs/SliderImages.vue";
import UgmMachineInfo from "@/components/Ugm/UgmMachineInfo.vue";
import UgmMachineTabs from "@/components/Ugm/UgmMachineTabs.vue";
import UgmRelated from "@/components/Ugm/UgmRelated.vue";
import axios from "axios";
export default {
    components: {
        Header,
        Footer,
        BreadCrumbs,
        FaqBlock,
        MainContentWrapper,
        SliderImages,
        UgmMachineInfo,
        UgmMachineTabs,
        UgmRelated,
    },
    data() {
        return {
            machine: null,
            related: [],
            error: null,
        }
    },
    methods: {
        getData() {
            const sku = this.$route.params.slug;
            if (!sku) return;
            this.machine = null;
            this.error = null;
            axios.get(`/ugm/machines/${encodeURIComponent(sku)}`).then(resp => {
                if (sku !== this.$route.params.slug) return;
                this.machine = resp.data.data;
                this.related = resp.data.related;
                document.title = this.machine.title;
                this.updateMetaDescription(this.machine.description.slice(0, 160));
            }).catch(error => {
                this.error = error.response && error.response.status === 404 ? 'not_found' : 'unavailable';
            });
        },
        updateMetaDescription(content) {
            let tag = document.querySelector(`meta[name='description']`);
            if (!tag) {
                tag = document.createElement("meta");
                tag.setAttribute("name", "description");
                document.head.appendChild(tag);
            }
            tag.setAttribute("content", content);
        },
    },
    mounted() {
        this.getData();
    },
    watch: {
        '$route.params.slug'() {
            this.getData();
        },
    },
}
</script>

<style scoped>
.status{
    padding: 120px 0;
    text-align: center;
    color: rgb(85, 98, 114);
    font-size: 16px;
    font-weight: 500;
    line-height: 140%;
    border-top: 1px solid rgb(222, 230, 234);
}
.status a{
    display: block;
    margin-top: 16px;
    color: rgb(5, 5, 5);
    text-decoration: underline;
    text-decoration-color: rgb(255, 183, 16);
    text-underline-offset: 4px;
}
</style>
